export const vegetables = [
        {
            category: 'Cijene voća',
            text: 'Cijene voća na pijacama u Crnoj Gori',
            config: 'montenegroFruit',
            subcategories:[
            {
                name: 'Jabuka',
                text: 'Cijene jabuke na pijacama u Crnoj Gori'
            },
            {
                name: 'Breskva',
                text: 'Cijene breskvi na pijacama u Crnoj Gori'
            },
            {
                name: 'Kajsija',
                text: 'Cijene kajsija na pijacama u Crnoj Gori'
            },
            {
                name: 'Trešnja',
                text: 'Cijene trešanja na pijacama u Crnoj Gori'
            },
            {
                name: 'Jagoda',
                text: 'Cijene jagoda na pijacama u Crnoj Gori'
            },
            {
                name: 'Kivi',
                text: 'Cijene kivija na pijacama u Crnoj Gori'
            },
            {
                name: 'Šljiva',
                text: 'Cijene šljiva na pijacama u Crnoj Gori'
            },
            {
                name: 'Banana',
                text: 'Cijene banana na pijacama u Crnoj Gori'
            },
            {
                name: 'Grožđe',
                text: 'Cijene grožđa na pijacama u Crnoj Gori'
            },
            {
                name: 'Kruška',
                text: 'Cijene krušaka na pijacama u Crnoj Gori'
            },
            {
                name: 'Nandža',
                text: 'Cijene narandže na pijacama u Crnoj Gori'
            },
           
            {
                name: 'Borovnica',
                text: 'Cijene borovnice na pijacama u Crnoj Gori'
            },
            {
                name: 'Lubenica',
                text: 'Cijene lubenice na pijacama u Crnoj Gori'
            },
            {
                name: 'Dinja',
                text: 'Cijene dinje na pijacama u Crnoj Gori'
            },
            {
                name: 'Višnja',
                text: 'Cijene višanja na pijacama u Crnoj Gori'
            },
            {
                name: 'Malina',
                text: 'Cijene malina na pijacama u Crnoj Gori'
            },
            {
                name: 'Mandarina',
                text: 'Cijene mandarine na pijacama u Crnoj Gori'
            },
            {
                name: 'Limun',
                text: 'Cijene limuna na pijacama u Crnoj Gori'
            },
            {
                name: 'Grejpfrut',
                text: 'Cijene grejpfruta na pijacama u Crnoj Gori'
            },
            
        ]
        },
        {
            category: 'Cijene povrća',
            text: 'Cijene povrća na pijacama u Crnoj Gori',
            config: 'montenegroVege',
            subcategories:[
            {
                name: 'Krompir',
                text: 'Cijene krompira na pijacama u Crnoj Gori'
            },
            {
                name: 'Paradajz',
                text: 'Cijene paradajza na pijacama u Crnoj Gori'
            },
            {
                name: 'Luk bijeli',
                text: 'Cijene bijelog luka na pijacama u Crnoj Gori'
            },
            {
                name: 'Luk crni',
                text: 'Cijene crnog luka na pijacama u Crnoj Gori'
            },
            {
                name: 'Luk crveni',
                text: 'Cijene crvenog luka na pijacama u Crnoj Gori'
            },
            {
                name: 'Praziluk',
                text: 'Cijene praziluka na pijacama u Crnoj Gori'
            },
            {
                name: 'Kupus',
                text: 'Cijene kupusa na pijacama u Crnoj Gori'
            },
            {
                name: 'Špagore',
                text: 'Cijene špagore na pijacama u Crnoj Gori'
            },
            {
                name: 'Spanać',
                text: 'Cijene spanaća na pijacama u Crnoj Gori'
            },
            {
                name: 'Krastavac',
                text: 'Cijene krastavaca na pijacama u Crnoj Gori'
            },
            {
                name: 'Tikvice',
                text: 'Cijene tikvica na pijacama u Crnoj Gori'
            },
            {
                name: 'Patlidžan',
                text: 'Cijene patlidžana na pijacama u Crnoj Gori'
            },
            {
                name: 'Rotkvica',
                text: 'Cijene rotkvice na pijacama u Crnoj Gori'
            },
            {
                name: 'Šargarepa',
                text: 'Cijene šargarepe na pijacama u Crnoj Gori'
            },
            {
                name: 'Zelena salata',
                text: 'Cijene zelene salate na pijacama u Crnoj Gori'
            },
            {
                name: 'Šampinjoni',
                text: 'Cijene šampinjona na pijacama u Crnoj Gori'
            },
            {
                name: 'Boranija',
                text: 'Cijene boranije na pijacama u Crnoj Gori'
            },
            {
                name: 'Karfiol',
                text: 'Cijene karfiola na pijacama u Crnoj Gori'
            },
        ]
        },
        {
            category: 'Cijene stoke',
            text: 'Cijene stoke na pijacama u Crnoj Gori',
            config: 'montenegroCattle',
            subcategories:[
            {
                name: 'Prasad',
                text: 'Cijene prasadi na pijacama u Crnoj Gori'
            },
            {
                name: 'Jagnjad',
                text: 'Cijene jagnjadi na pijacama u Crnoj Gori'
            },
            {
                name: 'Telad',
                text: 'Cijene teladi na pijacama u Crnoj Gori'
            },
            {
                name: 'Junad',
                text: 'Cijene junadi na pijacama u Crnoj Gori'
            },
            {
                name: 'Krave za klanje',
                text: 'Cijene krava za klanje na pijacama u Crnoj Gori'
            },
            {
                name: 'Tovljenici',
                text: 'Cijene tovljenika na pijacama u Crnoj Gori'
            },
            {
                name: 'Krmače za klanje',
                text: 'Cijene krmača za klanje na pijacama u Crnoj Gori'
            },
            {
                name: 'ovce',
                text: 'Cijene ovaca na pijacama u Crnoj Gori'
            },
            {
                name: 'Koze',
                text: 'Cijene koza na pijacama u Crnoj Gori'
            },
            {
                name: 'Jarad',
                text: 'Cijene jaradi na pijacama u Crnoj Gori'
            },
            {
                name: 'Bikovi',
                text: 'Cijene bikova na pijacama u Crnoj Gori'
            },
            {
                name: 'Priplodne nazimice',
                text: 'Cijene priplodnih nazimica na pijacama u Crnoj Gori'
            },
            {
                name: 'Ovnovi za priplod',
                text: 'Cijene ovnova za priplod na pijacama u Crnoj Gori'
            },
        ]
        }
    ]
 
